import { Box, Tab, Tabs } from '@mui/material'

import { useProject } from 'contexts/project'
import { SyntheticEvent } from 'react'
import ChipText from 'utils/project/chip-text'
import BadgeConnector from 'utils/project/connector-badge'
import OrganizationHeader from '../organization-header'
import { useStyles } from './styles'

interface IProjectHeaderProps {
  handleBackPage: () => void
}

const ProjectHeader = ({ handleBackPage }: IProjectHeaderProps) => {
  const { data: project, changeTab, selectedTab, tabOptions } = useProject()
  const classes = useStyles()

  const handleChangeTab = (_: SyntheticEvent, newValue: number) => {
    changeTab(newValue)
  }

  if (!project) {
    return null
  }

  return (
    <Box className={classes.headerContainer}>
      {/* <Box className={classes.headerBack}>
        <ArrowBack
          fontSize='small'
          color='primary'
          onClick={handleBackPage}
          sx={{ cursor: 'pointer' }}
        />
        <h1>{project.name}</h1>
      </Box> */}

      <table className={classes.tableBase}>
        <thead className={classes.tableHeader}>
          <tr>
            <th className={classes.tableOrganization}>Organização</th>
            <th className={classes.tableConnectors}>Conectores</th>
            <th className={classes.tableApps}>Apps</th>
            <th className={classes.tableProcess}>Família</th>
          </tr>
        </thead>

        <tbody className={classes.tableBody}>
          <tr>
            <td className={classes.tableOrganization}>
              <OrganizationHeader
                corporateName={project.organizationOutput?.corporateName}
                isInactive={project.isInactive}
              />
            </td>
            <td className={classes.tableConnectors}>
              <Box className={classes.connectors}>
                {project.connectors.map((connector, index) => (
                  <BadgeConnector
                    key={index}
                    name={connector.name}
                    index={index}
                  />
                ))}
              </Box>
            </td>
            <td className={classes.tableApps}>
              <Box className={classes.connectors}>
                {project?.recipes
                  .filter((recipe) => recipe.type == 'app')
                  .map((connector, index) => (
                    <BadgeConnector
                      key={index}
                      name={connector.appName}
                      index={index}
                    />
                  ))}
              </Box>
            </td>
            <td className={classes.tableProcess}>
              <Box className={classes.tags}>
                {project.tags.map((tag, index) => (
                  <ChipText
                    key={index}
                    text={tag}
                    color='processing'
                  />
                ))}
              </Box>
            </td>
          </tr>
        </tbody>
      </table>

      <Tabs
        value={selectedTab}
        onChange={handleChangeTab}
        aria-label='Project Tabs'
      >
        {tabOptions.map((tab, index) => (
          <Tab
            label={tab}
            key={index}
            id={`simple-tab-${index}`}
            aria-controls={`simple-tabpanel-${index}`}
          />
        ))}
      </Tabs>
    </Box>
  )
}

export default ProjectHeader
